import { IIconProps } from '../../types/IconProps.interface'

export const IconInfoCircle = ({ color = 'white' }: IIconProps) => {
  return (
    <svg fill='none' height='15' viewBox='0 0 15 15' width='15' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.5 1.31134e-06C11.6421 2.03558e-06 15 3.35787 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 -2.03558e-06 11.6421 -1.31134e-06 7.5C-3.29405e-07 3.35786 3.35786 8.44819e-07 7.5 1.31134e-06ZM7.5 1C3.91015 1 1 3.91015 0.999999 7.5C0.999998 11.0899 3.91015 14 7.5 14C11.0898 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1ZM7.5 7C7.77614 7 8 7.22386 8 7.5L8 10.5C8 10.7761 7.77614 11 7.5 11C7.22386 11 7 10.7761 7 10.5L7 7.5C7 7.22386 7.22386 7 7.5 7ZM7.5 3.75C7.91421 3.75 8.25 4.08579 8.25 4.5C8.25 4.91422 7.91421 5.25 7.5 5.25C7.08579 5.25 6.75 4.91421 6.75 4.5C6.75 4.08579 7.08579 3.75 7.5 3.75Z'
        fill={color}
      />
    </svg>
  )
}
